var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.canVerifOcr
        ? _c("CompassButton", {
            attrs: {
              label: _vm.$t.__("common.actions.verify"),
              type: "tertiary",
              disabled: _vm.disableVerify
            },
            on: { click: _vm.goToVerif }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.canVerifOcr
        ? _c("CompassButton", {
            attrs: {
              label: _vm.$t.__("common.actions.delete"),
              type: "tertiary-destructive"
            },
            on: { click: _vm.deleteFile }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }